import TagifyController from '../tagify_controller'

export default TagifyController
